var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckInIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 33",
    width: 38,
    height: 31,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check_in_icon-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #53b7e8 } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m18.8 18.1h-15v-3.4h15v-5l8.4 6.7-8.4 6.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m27.9 2.5c1.8 0.8 3.5 1.9 4.9 3.3 2.8 2.8 4.4 6.6 4.4 10.6 0 4-1.6 7.8-4.4 10.6-2.9 2.9-6.6 4.4-10.6 4.4-4 0-7.8-1.5-10.6-4.4l2.3-2.3c2.2 2.2 5.1 3.4 8.3 3.4 3.1 0 6-1.2 8.2-3.4 2.2-2.2 3.4-5.2 3.4-8.3 0-3.1-1.2-6-3.4-8.2-2.2-2.2-5.1-3.5-8.2-3.5-3.2 0-6.1 1.3-8.3 3.5l-2.3-2.4c1.3-1.4 3-2.5 4.8-3.3 1.8-0.7 3.8-1.1 5.8-1.1 1.9 0 3.9 0.4 5.7 1.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInIcon);
export default __webpack_public_path__ + "static/media/check_in_icon.2a87204525ff076700ec4c4b77193297.svg";
export { ForwardRef as ReactComponent };